import { render, staticRenderFns } from "./PriceTags.vue?vue&type=template&id=a6711a2e&scoped=true&"
import script from "./PriceTags.vue?vue&type=script&lang=js&"
export * from "./PriceTags.vue?vue&type=script&lang=js&"
import style0 from "./PriceTags.vue?vue&type=style&index=0&id=a6711a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6711a2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VPagination,VSelect,VSwitch,VTextField})
